export default __webpack_public_path__ + "static/media/partner1.132b314c.webp";